module.exports = __webpack_public_path__ + "static/media/loginScreen.69495418.jpg";